import { supabase } from './supabase';

const EPIC_WEEK_REMAP: Record<string, string> = {
  // Epic Week 2026 (26/10–01/11): versiones _v2 (aclaran entrega inmediata, sin el "PD" a otro número)
  order_confirmation_util: 'order_confirmation_epic_week_v2',
  cash_order_confirmation: 'cash_order_confirmation_epic_week_v2',
};

export function applyEpicWeekRemap(templateName: string, useEpicWeek: boolean): string {
  if (!useEpicWeek) return templateName;
  return EPIC_WEEK_REMAP[templateName] || templateName;
}

export async function isEpicWeekActive(): Promise<boolean> {
  try {
    const { data } = await supabase
      .from('cost_settings')
      .select('use_epic_week_templates, epic_week_starts_at, epic_week_ends_at')
      .single();
    // se apaga sola al llegar epic_week_ends_at (migr 115)
    if (data?.epic_week_ends_at && new Date(data.epic_week_ends_at).getTime() <= Date.now()) return false;
    if (data?.epic_week_starts_at && new Date(data.epic_week_starts_at).getTime() > Date.now()) return false;
    return Boolean(data?.use_epic_week_templates);
  } catch {
    return false;
  }
}

export async function resolveTemplateName(templateName: string): Promise<string> {
  const useEpicWeek = await isEpicWeekActive();
  return applyEpicWeekRemap(templateName, useEpicWeek);
}

// Elige el template de confirmación de orden según medio de pago + envío.
// - efectivo + retiro → cash_order_confirmation (flujo normal)
// - efectivo + envío  → cash_shipping_decision (template con botones para que el cliente
//                       elija retirar o cambiar medio de pago)
// - resto             → order_confirmation_util
export function resolveOrderConfirmationTemplate(order: {
  payment_details?: { method?: string } | null;
  delivery_type?: string;
  shipping_option?: string;
}): 'order_confirmation_util' | 'cash_order_confirmation' | 'cash_shipping_decision' {
  const isCash = order.payment_details?.method === 'custom';
  if (!isCash) return 'order_confirmation_util';

  const so = (order.shipping_option || '').toLowerCase();
  const isPickup =
    order.delivery_type === 'retiro' ||
    so === 'local' ||
    so === 'local (local)' ||
    so.startsWith('local (');

  return isPickup ? 'cash_order_confirmation' : 'cash_shipping_decision';
}
